import * as React from 'react';
import { CookiesProvider } from 'react-cookie';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-datepicker/dist/react-datepicker.css';

import 'react-toastify/dist/ReactToastify.css';
import AppLayout from './components/appLayout';
import './index.css';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import { appStore, registerSagas } from './store/appStore';
import { initSentry } from './utils/sentry';

initSentry();

registerSagas();

ReactDOM.render(
  <Provider store={appStore}>
    <CookiesProvider>
      <BrowserRouter>
        <>
          <ToastContainer newestOnTop />
          <AppLayout />
        </>
      </BrowserRouter>
    </CookiesProvider>
  </Provider>,
  document.getElementById('root') as HTMLElement,
);
unregisterServiceWorker();
